import { isNullOrUndefinedOrEmpty } from '@/utils/checkValue/string';
/**
 * 整数判定
 * @param text
 */
export const isInteger = (text) => (value) => {
    const isEmptyValue = isNullOrUndefinedOrEmpty(value);
    const matchResult = !isEmptyValue && String(value).match(/^\d+$/);
    return !isEmptyValue && !matchResult ? text : '';
};
